import React from 'react'; 
import './Sliders.css'
import { MenuPattern } from '../'
import { useSelector } from 'react-redux'

export function Sliders({
    choiceDate,
    handleAddDish,
    products,
    handleDeleteMenuDay,
    handleAddExcessDish,
    handleDeleteRecipe,
    handleEdite,
    blockedSaveMenus,
    handleAutoReplaceMenu,
    handleAutoReplaceDish,
    handleCopyRecipe,
    handleCopyPlan,
    handleAutoMeals,
    optionsId,
    normalPlan,
    handleChangeCount,
    clickCreate,
    showRecipes,
    returnModal,
  }) {
    const {recipesLimitData, statusLim} = useSelector(state => state.recipes) 
    const [step, setStep] = React.useState(3);
    const [slide, setSlide] = React.useState(0);
    const [isTransitioning, setIsTransitioning] = React.useState(false);
    const sliderRef = React.useRef(null);
    const [isMobile, setIsMobile] = React.useState(false);
    const length = products.length
    // Сортируем и вычисляем данные для слайдера
    const sortedItems = React.useMemo(() => [...products].sort((a, b) => a.date - b.date), [products]);
    const totalSlides = Math.ceil(sortedItems.length / step);
    const showArrows = sortedItems.length > step;
    const [currentSlide, setCurrentSlide] = React.useState(0); 
    const showPrevArrow = showArrows && slide > 0;
    const [transitionEnabled, setTransitionEnabled] = React.useState(true);
    const showNextArrow = showArrows && slide < totalSlides - 1;
    const [startX, setStartX] = React.useState(null);
    const [isSwiping, setIsSwiping] = React.useState(false);
   
    React.useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 660); // Пример для 768px
      };
      
      handleResize(); // Проверить сразу при загрузке
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleTouchStart = (e) => {
      setStartX(e.touches[0].clientX);
      setIsSwiping(true);
    };
    
    const handleTouchMove = (e) => {
      if (!isSwiping) return;
      const currentX = e.touches[0].clientX;
      const diffX = startX - currentX;
      
      // Определяем направление свайпа
      if (Math.abs(diffX) > 50) { // Порог для определения свайпа
        if (diffX > 0) { 
          // Свайп влево - следующий слайд
          setCurrentSlide(prev => Math.min(prev + 1, sortedItems.length - 1));
        } else { 
          // Свайп вправо - предыдущий слайд
          setCurrentSlide(prev => Math.max(prev - 1, 0));
        }
        setIsSwiping(false);
      }
    };

    const handleTouchEnd = () => {
      setIsSwiping(false);
    };

    // Обработчик изменения размера окна
    React.useEffect(() => {
      const updateStep = () => {
        const width = window.innerWidth;
        if (width > 1024) setStep(3);
        else if (width < 660) setStep(1);
        else setStep(2);
      };
  
      window.addEventListener('resize', updateStep);
      updateStep();
      return () => window.removeEventListener('resize', updateStep);
    }, []);
  
    // Сброс слайда при изменении даты
    React.useEffect(() => setSlide(0), [choiceDate]);
  
    // Анимация перехода
    const changeSlide = (direction) => {
      if (isTransitioning) return;
      
      setIsTransitioning(true);
      const newSlide = (slide + direction + totalSlides) % totalSlides;
      setSlide(newSlide);
      
      setTimeout(() => setIsTransitioning(false), 300);
    };
  
    return (
      <>
      { !isMobile && 
        <div className='slider__desktop'>
        <button 
          onClick={() => changeSlide(-1)}
          className={`arrow prev-button ${isTransitioning ? 'disabled' : length <= step ? 'button__none' : ''}`}
          disabled={isTransitioning}
          aria-label="Previous slide"
        />
       
        
      <div className="slider" ref={sliderRef}>
        
        <div 
          className={`slide-list ${isTransitioning ? 'transition' : ''}`}
          style={{ transform: `translateX(-${slide * (step === 3 ? 102 : 101)}%)` }}
        >
          {sortedItems.map((item) => (
            <div className="slide" key={item.date}>
              <MenuPattern
                item={item}
                clickCreate={clickCreate}
                handleAddDish={handleAddDish}
                handleChangeCount={handleChangeCount}
                handleDeleteMenuDay={handleDeleteMenuDay}
                handleAddExcessDish={handleAddExcessDish}
                handleDeleteRecipe={handleDeleteRecipe}
                handleEdite={handleEdite}
                blockedSaveMenus={blockedSaveMenus}
                handleAutoReplaceMenu={handleAutoReplaceMenu}
                handleAutoReplaceDish={handleAutoReplaceDish}
                handleCopyRecipe={handleCopyRecipe}
                handleCopyPlan={handleCopyPlan}
                handleAutoMeals={handleAutoMeals}
                optionsId={optionsId}
                normalPlan={normalPlan}
                showRecipes={showRecipes}
                returnModal={returnModal}
              />
            </div>
          ))}
        </div>
        
      
      </div>
      <button 
        onClick={() => changeSlide(1)}
        className={`arrow next-button ${isTransitioning ? 'disabled' : length <= step ? 'button__none' : ''}`}
        disabled={isTransitioning}
        aria-label="Next slide"
      />
        
      </div>
          }
          {isMobile && 
      <div className='slider__mobile' onTouchStart={handleTouchStart}  onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
          <div 
            className='slider__mobile_track' 
            style={{ 
              transform: `translateX(-${currentSlide * 100}%)` 
            }}
          >
            {sortedItems.map((item) => (
          <div className='slider__mobile_slide' key={item.date}>
            <MenuPattern
              item={item}
              clickCreate={clickCreate}
              handleAddDish={handleAddDish}
              handleChangeCount={handleChangeCount}
              handleDeleteMenuDay={handleDeleteMenuDay}
              handleAddExcessDish={handleAddExcessDish}
              handleDeleteRecipe={handleDeleteRecipe}
              handleEdite={handleEdite}
              blockedSaveMenus={blockedSaveMenus}
              handleAutoReplaceMenu={handleAutoReplaceMenu}
              handleAutoReplaceDish={handleAutoReplaceDish}
              handleCopyRecipe={handleCopyRecipe}
              handleCopyPlan={handleCopyPlan}
              handleAutoMeals={handleAutoMeals}
              optionsId={optionsId}
              normalPlan={normalPlan} 
              returnModal={returnModal}
            />
          </div>
        ))}
          </div>
          
          {/* Индикаторы слайдов */}
          <div className='slider__indicators'>
            {sortedItems.map((_, index) => (
              <button
                key={index}
                className={`slider__indicator_item ${index === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </div> 

            }
 
    </>
    );
  }